import { styled } from '@mui/material';

export interface MessageBubbleProps {
  icon: React.ReactNode;
  content: React.ReactNode;
}

export const MessageBubble = ({ icon, content }: MessageBubbleProps) => {
  return (
    <Layout data-testid="message-bubble">
      <LayoutIcon>{icon}</LayoutIcon>
      <LayoutContent>{content}</LayoutContent>
    </Layout>
  );
};

const Layout = styled('div')`
  display: flex;
  gap: ${({ theme }) => theme.spacing(12 / 8)};
`;

const LayoutIcon = styled('div')`
  flex: 0 0 30px;
`;

const LayoutContent = styled('div')`
  flex: 1 1 auto;
`;
